export default __webpack_public_path__ + "static/media/workplace-share.66a0d0f7.png";